// extracted by mini-css-extract-plugin
module.exports = {"container-textarea":"textarea_container-textarea__1MkKC","count-characters":"textarea_count-characters__3r67m"};